import { Option } from '../types/shared.js';

export type OffsetSubordersMeta = {
  filters: {
    statusFilters: { name: string; label: string }[];
    sortBy: { name: string; label: string }[];
  };
};

export enum Co2OrderStatus {
  Draft = 'draft',
  Booked = 'booked',
  Invoiced = 'invoiced',
  Rejected = 'rejected',
}

export type Co2Filter = {
  show: Option<string>;
  sortBy: Option<string>;
  search: string;
  selected: boolean;
};

export type Co2Order = {
  id: number;
  campaignCollectionName: string;
  mediaPlanName: string;
  dateFrom: string;
  dateTo: string;
  emissions: string;
  offsetCost: string;
  orderStatus: Co2OrderStatus;
  verifyUrl: string;
  isCurrencyConverted: boolean;
  displayCurrency: string;
};

export type Co2OrdersReq = {
  campaignCollectionId: number;
  page: number;
  pageSize: number;
  sortBy: string;
  statusFilter: string;
  mediaPlanName: string;
};

export type GetCo2OrdersRes = {
  lastPage: number;
  orders: Co2Order[];
  certificateAcknowledged: boolean;
};

export type BlobResponse = {
  blob: Blob;
  fileName: string;
};

export type AcknowledgmentModalState =
  | {
      isOpen: true;
      certificateUrl: string;
    }
  | { isOpen: false; certificateUrl: null };
